webpackJsonp([85204117838356],{

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Wantsome-elk-for-beginners.7fe70526.png";

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WantsomeElkForBeginners = __webpack_require__(559);
	
	var _WantsomeElkForBeginners2 = _interopRequireDefault(_WantsomeElkForBeginners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elkWorkshop = function elkWorkshop() {
	    return _react2.default.createElement(
	        'section',
	        { id: 'interview', className: 'parallax-section' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'team-wrapper' },
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement('div', { className: 'col-md-1' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-10' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Community workshop: ELK Stack for beginners'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(
	                                            'b',
	                                            null,
	                                            'Powered by Wantsome'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement('div', { className: 'col-md-1' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement('img', { src: _WantsomeElkForBeginners2.default, className: 'img-responsive', alt: 'Wantsome Workshop' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'Location:'
	                                    ),
	                                    ' International Hotel, Iasi',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'Cost:'
	                                    ),
	                                    ' Free',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'Trainers:'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    'Stefan Caraiman - Senior DevOps Engineer',
	                                    _react2.default.createElement('br', null),
	                                    'Gabriel Ichim - DevOps Consultant',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'Schedule:'
	                                    ),
	                                    ' Saturday, 28 March',
	                                    _react2.default.createElement('br', null),
	                                    'Welcome:  13:30 \u2013 14:00',
	                                    _react2.default.createElement('br', null),
	                                    'Workshop: 14:00 \u2013 18:00',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    '*Hands-On experience, you need your laptop.'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        'About the trainers'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'Stefan Caraiman'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    'Stefan started working as a Python developer on various opensource projects from the Openstack platform. He found out how easily Python can combine with the DevOps mindset and made the switch to becoming a DevOps Engineer. Besides Python, his other "sweet tooth" technologies are Continous Integration, Delivery and Deployment, Golang, Linux quirks and anything "as Code" related. ',
	                                    _react2.default.createElement('br', null),
	                                    'You can find more of his random thoughts on his blog at ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://stefan-caraiman.github.io/', target: '_blank' },
	                                        'stefan-caraiman.github.io'
	                                    ),
	                                    '.',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'Gabriel Ichim'
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    'Gabriel started out as a system administrator in the web hosting industry but quickly discovered how valuable DevOps practices are in the IT world. ',
	                                    _react2.default.createElement('br', null),
	                                    'He has been working on building the cloud architecture for several governmental applications while automating the processes along the way. He\'s eager to find solutions for complex technical challenges and keeps looking for better ways to optimize the workflow of any applications.',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null)
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        'Description'
	                                    ),
	                                    'Getting information from your systems might be easy but using the data in a manner that brings value is challenging. By using the right tools to collect, parse and index your data in a central place you solve some of the puzzles. But then you need to interactively explore, visualize, share insights into your data and alert the on-call team before the end-user notices any service disruption.',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    'This workshop focuses on how to use the ELK stack (Elasticseach, Kibana, Logstash, and Beats) to build an end-to-end system for monitoring and log aggregation:',
	                                    _react2.default.createElement('br', null),
	                                    'Getting useful information using Beats collectors',
	                                    _react2.default.createElement('br', null),
	                                    'Parsing and transforming data on the fly with Logstash',
	                                    _react2.default.createElement('br', null),
	                                    'Understanding how the Elasticseach search engine is capable of returning the best results in a matter of seconds',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        'Level'
	                                    ),
	                                    'Beginner level',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        'Objectives'
	                                    ),
	                                    'Understand the purpose and use case for each of the tools',
	                                    _react2.default.createElement('br', null),
	                                    'Ability to perform basic queries in Elasticseach',
	                                    _react2.default.createElement('br', null),
	                                    'Ability to build simple visualizers and dashboards in Kibana',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        'Prerequisites'
	                                    ),
	                                    'Basic Linux knowledge',
	                                    _react2.default.createElement('br', null),
	                                    'Basic Git knowledge',
	                                    _react2.default.createElement('br', null),
	                                    'Git installed on the local machine',
	                                    _react2.default.createElement('br', null),
	                                    'OpenVPN installed on the local machine',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        'Agenda'
	                                    ),
	                                    '1. Understand the scope of each component in the ELK stack',
	                                    _react2.default.createElement('br', null),
	                                    '2. Run the stack (Logstash, Kibana, Elasticsearch) on the Openstack platform',
	                                    _react2.default.createElement('br', null),
	                                    '3. Ingest data (logs and metrics) from different sources (Beats) into ELK',
	                                    _react2.default.createElement('br', null),
	                                    '4. Filter data on ogstash',
	                                    _react2.default.createElement('br', null),
	                                    '5. Perform basic queries in Elasticseach',
	                                    _react2.default.createElement('br', null),
	                                    '6. Build dashboards on Kibana',
	                                    _react2.default.createElement('br', null),
	                                    '7. QA session',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        'Registration'
	                                    ),
	                                    'The access is free for you! All you have to do is register here until 24 March and our team will get back to you with the confirmation. Because the workshop has a limited number of places, your seat will not be confirmed until you receive our response.',
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement('br', null),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'btn btn-info btn-tickets', href: 'https://www.eventbrite.com/e/elk-stack-for-beginners-tickets-98582933207', target: '_blank' },
	                                        ' Go to registration '
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = elkWorkshop;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-community-events-elk-stack-beginners-js-005e5d9de89323b3c004.js